import React from 'react';
import type { VisualFractionPart } from '../types';
import { getInteractiveProps } from './part-interactions';
import { getGridColumnCount } from '../../../utils/visual-fraction-geometry';

interface GridShapeProps {
  parts: VisualFractionPart[];
  divisions: number;
  onPartClick: (index: number) => void;
}

/**
 * Grid shape — always 2-D square layout, orientation prop is ignored.
 * `divisions` must be a perfect square (enforced by zod schema).
 */
export const GridShape: React.FC<GridShapeProps> = ({
  parts,
  divisions,
  onPartClick,
}) => (
  <div
    className="visual-fraction-widget__parts visual-fraction-widget__parts--horizontal"
    style={{
      '--visual-fraction-divisions': divisions,
      '--visual-fraction-grid-cols': getGridColumnCount(divisions),
      // Safe integer division: zod schema enforces divisions = perfect square.
      '--visual-fraction-grid-rows': divisions / getGridColumnCount(divisions),
    } as React.CSSProperties}
  >
    {parts.map(part => (
      <div
        key={part.index}
        className={part.className}
        style={part.style}
        {...getInteractiveProps(part, onPartClick)}
      />
    ))}
  </div>
);

GridShape.displayName = 'GridShape';
